export default "/assets/images/filter-recommandation-BS.8bfe57427784da70.webp";